
import React, { createContext, useContext } from "react";
import { useOfflineCache, UseOfflineCacheData } from "./useOfflineCache";


type IOfflineCacheContext = UseOfflineCacheData

const noop = () => null as any;

const defaultData: IOfflineCacheContext = {
    getItem: noop,
    setItem: noop,
    clearItem: noop,
    online: true
}


const context = createContext<IOfflineCacheContext>(defaultData);
const { Provider } = context;

export const useOfflineCacheContext = () => {
    const offlineCache = useContext(context);
    if (!offlineCache) throw Error("Cannot call useOfflineCacheContext outside OfflineCacheProvider")
    return offlineCache;
};


export const OfflineCacheProvider: React.FC = ({ children }) => {
    const data = useOfflineCache();
    return (
        <Provider value={data}>
            {children}
        </Provider>
    );
};
